import React from 'react'

const _importFns: Array<() => Promise<unknown>> = []

export const lazyRoute =
  (fn: () => Promise<Record<string, unknown>>, key?: string) => {
    _importFns.push(fn)
    return () =>
      fn().then((m) => ({
        Component: (key ? m[key] : m.default) as React.ComponentType,
      }))
  }

export function prefetchRoutes() {
  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(() => _importFns.forEach((fn) => fn()))
  } else {
    setTimeout(() => _importFns.forEach((fn) => fn()), 200)
  }
}
